import { Component, OnInit,  ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
declare var $: any;
import * as _ from 'lodash';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { AlertComponent } from '../../alert/alert.component';
import { UpsiMasterService } from 'src/app/services/upsi-master.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-upsi-master',
  templateUrl: './upsi-master.component.html',
  styleUrls: ['./upsi-master.component.css']
})
export class UpsiMasterComponent implements OnInit {
  item: any;
  ItemList: any;
  itemId: any;
  disabledText: boolean;
  deleteId:any;
  disabledOnclick: boolean;
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  constructor( private alert: AlertComponent, private upsiMasterService: UpsiMasterService ) { }

  ngOnInit() {
    var companyDetails = JSON.parse(localStorage.getItem("companyDetails"));
    this.dtOptions = {
      processing: true,
      serverSide: false,
      scrollX: true,
      deferRender: true,
      stateSave: true,
      stateDuration: -1,
      scrollY: "420px",
      scrollCollapse: true,
      destroy: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'desc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'Nature of UPSI',
          title: 'Nature of UPSI',
          extend: 'excel',
          exportOptions: {
            columns: [0, 1, 2],
            format: {
              body: function ( data, row, column, node ) {
                  if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                    if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                  }else{ return data }
                }
            }
          },
        },
        {
          text: '<i class="fa fa-files-o"></i> Export to PDF',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'Nature of UPSI',
          title: 'Nature of UPSI',
          orientation: 'landscape',
          pageSize: 'LEGAL',
          extend: 'pdf',
          exportOptions: {
            columns: [0, 1, 2]
          },
        }
      ]


    }

    var paramData = {
      companyID: companyDetails.companyID
    }
    this.getList(paramData);

  }
  addModel() {
    this.item = null
    this.itemId = null
    $("#AddModel").modal('show');
  }
  getList(paramData) {
    this.upsiMasterService.getList(paramData).subscribe(response => {
      if (response.status == 0) {
        if (this.dtElement.dtInstance != undefined) {
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
          });
        }
        this.dtTrigger.next();
        this.ItemList = response.data;
      }
    })
  }

  save(id) {
    this.disabledOnclick = true;
    var companyDetails = JSON.parse(localStorage.getItem("companyDetails"));
    var paramData = {
      companyID: companyDetails.companyID
    }
    if (_.size(this.item)) {
      this.disabledText = false;
      if (id) {
        this.upsiMasterService.addItem({ 'item': this.item, 'itemId': id }).subscribe(response => {
          this.disabledOnclick = false;
          if(response.status == 0){
            // Clear any previous route to prevent navigation to wrong page
            $("#route2").val('');
            this.alert.success(response.message);
          }else{
            this.alert.error('Nature of UPSI already exists.');
          }
         
          this.getList(paramData);
          $("#AddModel").modal('hide');
          console.log("test", response)
        })
      } else {
        this.upsiMasterService.addItem({ 'item': this.item }).subscribe(response => {
          this.disabledOnclick = false;
          if(response.status == 0){
            // Clear any previous route to prevent navigation to wrong page
            $("#route2").val('');
            this.alert.success(response.message);
          }else{
            this.alert.error('Nature of UPSI already exists.');
          }
          this.getList(paramData);
          $("#AddModel").modal('hide');
          console.log("test", response)
        })
      }

    } else {
      this.disabledText = true;

    }


  }

  edit(id) {
    this.itemId = id;
    this.upsiMasterService.editItem(id).subscribe(response => {
      if (response.status == 0) {
        $("#AddModel").modal('show');
        this.item = response.data[0].Item;
      }
      console.log("test", response)
    })
  }

  deletePop(id){

    this.deleteId  = id;
    $("#deleteConfirmation").modal('show')
  }

  delete() {
    var companyDetails = JSON.parse(localStorage.getItem("companyDetails"));
    var paramData = {
      companyID: companyDetails.companyID
    }
    this.upsiMasterService.delete(this.deleteId).subscribe((response) => {
      if (response.status == 1) {
        this.alert.error(response.message);
      } else {
        this.getList(paramData);
        // Clear any previous route to prevent navigation to wrong page
        $("#route2").val('');
        this.alert.success(response.message);
      }
    })

  }
}

